const getStudioListResponse = (response) => {
  const options = response?.data?.studios.map((studio) => {
    return {
      label: `${studio.room}, ${studio.name}`,
      value: studio.id,
      rawData: studio,
    };
  });

  return options || [];
};

export default getStudioListResponse;
